import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import type { VideoItem } from '@/mocks/videos';

interface VideoGridProps {
  title: string;
  icon: string;
  videos: VideoItem[];
  viewAllLink: string;
  viewAllText: string;
}

const VideoGrid = ({ title, icon, videos, viewAllLink, viewAllText }: VideoGridProps) => {
  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2.5">
            <div className="w-1 h-5 rounded-full bg-primary-500" />
            <h2 className="text-lg md:text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              {title}
            </h2>
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100/70">
              <i className={`${icon} text-sm text-primary-600`}></i>
            </div>
          </div>
          <Link
            to={viewAllLink}
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            {viewAllText}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {videos.slice(0, 6).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGrid;